// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"360":"3a38f51c","384":"cccd75f6","554":"a0addd5b","992":"1b907ebb"}[chunkId] + ".chunk.css";
};